import { http } from '@/api/http';
import { ApiResponseBody, Uuid } from '@/api/types';
import { getQuoteApiUrl } from './quote.paths';
import {
  QuoteApproveInternallyBody,
  QuoteStatusChangeBody,
  QuoteTotalsResponse,
  RouteQuote,
  RouteQuoteCustomer,
} from './quote.types';
import { Case } from '../case';

const getRouteQuote = async (routeQuoteId: string) => {
  const res = await http.get<ApiResponseBody<RouteQuote>>(getQuoteApiUrl.routeQuoteById(routeQuoteId));
  return res.data.data;
};

const getRouteQuoteCustomer = async (routeQuoteId: string) => {
  const res = await http.get<ApiResponseBody<RouteQuoteCustomer>>(getQuoteApiUrl.routeQuoteByIdCustomer(routeQuoteId));
  return res.data.data;
};

const getInvoiceQuote = async (caseId: string, documentId: string) => {
  const res = await http.get(getQuoteApiUrl.invoiceQuoteById(caseId, documentId), {
    responseType: 'arraybuffer',
    headers: {
      Accept: 'application/pdf',
    },
  });
  return res.data;
};

const generateQuote = async (caseId: string) => {
  const res = await http.post<ApiResponseBody<Case>>(getQuoteApiUrl.generateQuote(caseId));
  return res.data.data;
};

const rejectQuoteInternally = async ({ id, ...body }: Pick<QuoteStatusChangeBody, 'comment'> & { id: string }) => {
  const res = await http.post<ApiResponseBody<Case>>(getQuoteApiUrl.quoteRejectInternally(id), body);
  return res.data.data;
};

const approveQuoteInternally = async (body: QuoteApproveInternallyBody & { id: string }) => {
  const res = await http.post<ApiResponseBody<Case>>(getQuoteApiUrl.quoteApproveInternally(body.id), body);
  return res.data.data;
};

const rejectQuoteByTXCenter = async ({ id, ...body }: QuoteStatusChangeBody & { id: string }) => {
  const res = await http.post<ApiResponseBody<Case>>(getQuoteApiUrl.quoteRejectByTXCenter(id), body);
  return res.data.data;
};

const approveQuoteByTXCenter = async ({ id, ...body }: Pick<QuoteStatusChangeBody, 'comment'> & { id: string }) => {
  const res = await http.post<ApiResponseBody<Case>>(getQuoteApiUrl.quoteApproveByTXCenter(id), body);
  return res.data.data;
};

const sendQuoteToTXCenter = async ({ id, ...body }: Pick<QuoteStatusChangeBody, 'comment'> & { id: string }) => {
  const res = await http.post<ApiResponseBody<Case>>(getQuoteApiUrl.quoteSendToTXCenter(id), body);
  return res.data.data;
};

const recallQuote = async ({ id, comment }: { id: Uuid; comment: string }) => {
  const res = await http.post<ApiResponseBody<Case>>(getQuoteApiUrl.quoteRecall(id), {
    comment,
  });
  return res.data.data;
};

const quoteComment = async ({ id, ...body }: Pick<QuoteStatusChangeBody, 'comment'> & { id: string }) => {
  const res = await http.post<ApiResponseBody<Case>>(getQuoteApiUrl.quoteComment(id), body);
  return res.data.data;
};

const quoteApproveTxCenterProvider = async ({
  id,
  ...body
}: Pick<QuoteStatusChangeBody, 'comment'> & { id: string }) => {
  const res = await http.post<ApiResponseBody<Case>>(getQuoteApiUrl.quoteApproveTxCenterProvider(id), body);
  return res.data.data;
};

const getQuoteTotals = async (quoteIds: string[]) => {
  const res = await http.get<ApiResponseBody<QuoteTotalsResponse>>(getQuoteApiUrl.quoteTotals(), {
    params: {
      quoteIds: quoteIds.join(','),
    },
  });

  return res.data.data;
};

export const quoteApiFetcher = {
  getRouteQuote,
  getRouteQuoteCustomer,
  getInvoiceQuote,
  generateQuote,
  rejectQuoteInternally,
  approveQuoteInternally,
  rejectQuoteByTXCenter,
  approveQuoteByTXCenter,
  sendQuoteToTXCenter,
  recallQuote,
  quoteApproveTxCenterProvider,
  quoteComment,
  getQuoteTotals,
};
